export default __webpack_public_path__ + "static/media/kitchen4-afterC-1024w.56a234e5.webp";